<template>
    <div class="x_page">
        <div class="title"> <span class="con">东乡区经济分析</span> </div>

        <firstRow class="space"/>
        <sencondRow class="space"/>
        <threeRow class="space"/>
        <fourthRow class="space"/>
        <div class="y">
            <year class="year"/>
        </div>
    </div>
</template>

<script>
import firstRow from "./firstRow";
import sencondRow from './secondRow/index'
import threeRow from './threeRow/index'
import fourthRow from './fourthRow/index'
import year from "./TimeAxis";
export default {
    name: "",
    data() {
        return {};
    },
    methods: {},
    created() {},
    watch: {},
    components: {
        firstRow,
        sencondRow,
        threeRow,
        fourthRow,
        year,
    },
};
</script>

<style lang="less" scoped>
.x_page {
    width: 100%;
    height: 100%;
    background:url('../../assets/dongxiang/bk.jpg') no-repeat;
    background-size: 100% 100%;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    .title {
        font-size: 30px;
        text-align: center;
        // box-sizing: border-box;
        // padding: 30px;
        height: 75px;
        line-height: 75px;
        font-weight: 700;//加粗
        margin: 35px 0 20px 0;
        background: url('../../assets/dongxiang/head.png') no-repeat;
        .con{
            background-image: -webkit-linear-gradient(left bottom,#BDFDFF,#3DE1FC);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .space{
        margin-bottom: 10px;
    }
    .y {
        width: 100%;
        position: relative;
        margin: 25px 0 0 0;
    }
}
</style>
